import { render, staticRenderFns } from "./StepSummary.vue?vue&type=template&id=4519aa4e&scoped=true"
import script from "./StepSummary.vue?vue&type=script&lang=js"
export * from "./StepSummary.vue?vue&type=script&lang=js"
import style0 from "./StepSummary.vue?vue&type=style&index=0&id=4519aa4e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4519aa4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4519aa4e')) {
      api.createRecord('4519aa4e', component.options)
    } else {
      api.reload('4519aa4e', component.options)
    }
    module.hot.accept("./StepSummary.vue?vue&type=template&id=4519aa4e&scoped=true", function () {
      api.rerender('4519aa4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/onboarding/steps/StepSummary.vue"
export default component.exports